import { render } from "./agent.posts.vue?vue&type=template&id=ed6ad55c"
import script from "./agent.posts.vue?vue&type=script&lang=js"
export * from "./agent.posts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__